import React,{Component} from 'react';
import './_tabs.css';

export default class Tabs extends Component {

    state = {
        activeTabIndex : 0
    }

    _handleOnClick(tabIndex){
        const { activeTabIndex } = this.state
        this.setState({
            activeTabIndex : tabIndex === activeTabIndex ? activeTabIndex : tabIndex
        });
    }

    _renderTabs(){
        return this.props.children.map((child, index)=>{
            return React.cloneElement(child,{
                tabIndex : index,
                onClick : this._handleOnClick.bind(this),
                isActive : index === this.state.activeTabIndex,
                key: index
            })
        })
    }

    _renderTabContent(){
        const {children} = this.props;
        const {activeTabIndex} = this.state;
        if(children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    }

    render() { 
        return (
            <div className="tabs">
                <ul style={{display: 'flex', justifyContent: 'center'}}>
                    { this._renderTabs() }
                    {/* <li className="slider" style={this.props.propsSlider}></li> */}
                </ul>
                <div className="tab-conteudo">
                    { this._renderTabContent() }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tabs/Tabs.js